import React from 'react';
import { observer } from 'mobx-react';
import ModuleCustomizationListService from '../services/ModuleCustomizationListService';
import ModuleCustomizationListFilter from './ModuleCustomizationListFilter';

const ModuleCustomizationListFilterContainer = () => (
  <ModuleCustomizationListFilter
    values={ModuleCustomizationListService.form.getValues()}
    onChange={ModuleCustomizationListService.form.setValue}
    onSearch={ModuleCustomizationListService.search}
  />
);

export default observer(ModuleCustomizationListFilterContainer);
